import { ChatMessageProps } from 'interfaces/components/chatbot/ChatMessage';
import ChatSources from './ChatSources';
import ChatLoader from './ChatLoader';
import MarkdownRender from './MarkdownRender';

const ChatMessage = ({ message, bubbleMaxWidth }: ChatMessageProps) => {
  if (message.isLoading) {
    return <ChatLoader key={message.id} />;
  }

  if (message.isUser) {
    return (
      <div key={message.id} className='flex justify-end overflow-hidden'>
        <div
          className={`bg-green-250 rounded-2xl rounded-br-lg px-3 py-2 whitespace-pre-wrap`}
          style={{ maxWidth: `${bubbleMaxWidth}px`, overflowWrap: 'anywhere' }}
        >
          <p className='text-sm dark:text-black user-select-text break-words'>{message.content}</p>
        </div>
      </div>
    );
  }

  // Check if this message has sources
  const sources = message.sources;

  return (
    <div
      key={message.id}
      className={`bg-white w-fit dark:bg-gray-700 rounded-e-2xl rounded-ss-2xl rounded-es-lg px-3 py-2 border border-gray-400 dark:border-gray-500 whitespace-pre-wrap overflow-hidden`}
      style={{ maxWidth: `${bubbleMaxWidth}px`, overflowWrap: 'anywhere' }}
    >
      <div className='prose prose-sm dark:prose-invert max-w-none user-select-text break-words'>
        <MarkdownRender>
          {message.content}
        </MarkdownRender>
      </div>
      {sources && sources.length > 0 && (
        <div className='mt-4 pt-3 border-t border-gray-200 dark:border-gray-500'>
          <ChatSources sources={sources} />
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
